import { AgGridReact } from "ag-grid-react";
import { StatsInfo } from "../GameStats/stat-info-type";
import { useIsMobile } from "src/components/util/useBreakpoint";
import Styles from "./StatsDataGrid.module.scss";

type StatsDataGridProps = {
  grid: any;
  gridOptions: any;
  columnDefs: StatsInfo[];
  // Optional single-row "Team" totals, pinned to the bottom and styled bold.
  pinnedBottomRow?: any[];
};

// On phones, shrink the pinned name column and the numeric stat columns so the name
// plus ~5 stat columns are visible (scrollable like the GameChanger app), instead of
// the 1–2 columns that fit at the desktop widths. Left-aligned text columns (e.g. the
// per-game "Opponent" column) keep their width — only centered numeric stats shrink.
const MOBILE_LABEL_WIDTH = 128;
const MOBILE_STAT_WIDTH = 56;

export default function StatsDataGrid({ grid, gridOptions, columnDefs, pinnedBottomRow }: StatsDataGridProps) {
  const isMobile = useIsMobile();

  // Transform StatsInfo to AG-Grid ColDef format
  const agGridColumnDefs = columnDefs.map((col) => {
    const def: any = { ...col, headerName: col.name };
    if (isMobile) {
      if (def.pinned) {
        def.width = MOBILE_LABEL_WIDTH;
      } else if (def.cellStyle?.textAlign !== "left") {
        def.width = MOBILE_STAT_WIDTH;
      }
    }
    return def;
  });

  return (
    <div className={Styles.stickyItem}>
      <div className="ag-theme-quartz sticky-stats-grid">
        <AgGridReact
          domLayout="autoHeight"
          rowData={grid}
          pinnedBottomRowData={pinnedBottomRow}
          gridOptions={gridOptions}
          columnDefs={agGridColumnDefs}
          columnHoverHighlight={true}
        />
      </div>
    </div>
  );
}
